
export class ControllerRecordChangeNotificationModel
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }

    public CommandOrigin: number;
    public ControllerId: number;
    public Differences: any[];
    public IncomingConfiguration: any;
    public MessageIdIfResultOfUserRequest: string;
    public TypeCode: number;
    public WasResultOfUserRequest: boolean;
}
